/* phoenix responses recently expired campaigns with 410 status message
 *  but old ones with 404. Catalog Web redirects using below querystrings to distinguish these responses
 *  As for spec we will show seperate messages for each of them
 */
export enum CampaignExpiredStatus {
    EXPIRED = 'expired',
    NOT_FOUND = 'not_found',
}

export interface ExpiredCampaignDialogProps {
    show: boolean;
    showStatus: CampaignExpiredStatus;
    onClose: () => void;
}
